<template>
    <template v-if="!$store.state.waitingRequest">
        <main>
            <section>
                <div class="panel">
                    <div class="navigation">
                        <ul>
                            <li><i class="fas fa-heart"></i> Jeux aimés</li>
                            <li><i class="fas fa-users"></i> Amis</li>
                            <li><i class="fas fa-user-cog"></i> Paramètres</li>
                        </ul>
                    </div>

                    <div class="content">
                        <h2>Bonjour {{ userData.identifiant }} !</h2>

                        <p>Cet espace est en cours de réalisation, il sera fonctionnel dans les prochains jours.</p>

                        <a href="#" @click.prevent="logout">Me déconnecter</a>
                    </div>
                </div>
            </section>
            
            <div class="ad-banner">
                <ins class="adsbygoogle"
                data-ad-client="ca-pub-2512331316053279"
                data-ad-slot="6346220535"></ins>
            </div>
        </main>
    </template>
    <template v-else>
        <SkeletonCategorie />
    </template>
</template>

<script>
    import Session from '../mixins/userSession';
    import AddGoogleScripts from '../mixins/addGoogleScripts';
    import SkeletonCategorie from '../components/SkeletonCategorie.vue';

    export default {
        name: "UserPanel",
        mixins: [Session, AddGoogleScripts],
        components: {
            SkeletonCategorie
        },
        data() {
            return {
                metas : {
                    title: 'ClickTestCPS Games™ - Mon compte',
                    meta: [
                        { name: 'robots', content: 'none' },
                        {
                            property: 'og:image',
                            content: 'https://clicktestcps.fr/og-games.png'
                        },
                        {
                            property: 'og:title',
                            content: 'Jeux en ligne gratuits en un clic - Jeu FR '+new Date().getFullYear()+' sans inscription - Games™ par ClickTestCPS'
                        },
                        {
                            property: 'og:description',
                            content: 'Jouez à des centaines de jeux en ligne gratuitement et sans inscription. Une sélection unique de jeux en ligne gratuits alimentée quotidiennement'
                        }
                    ]
                }
            }
        },
        mounted() {
            useHead(this.metas);
            this.$store.commit('setRequestTrue');
        },
        methods: {
            dateFr(date) {
                function handleZeros(nbr, type = '') {
                    nbr = (type == 'mm') ? nbr++ : nbr;
                    let string = (nbr < 10) ? ('0' + nbr.toString()) : (nbr.toString());
                    return string;
                }

                let dd = handleZeros(date.getDate());
                let mm = handleZeros(date.getMonth()+1, 'mm');
                let yyyy = handleZeros(date.getFullYear());

                let hh = handleZeros(date.getHours());
                let ii = handleZeros(date.getMinutes());

                return dd + '/' + mm + '/' + yyyy + ' à ' + hh + ':' + ii;
            },
            logout() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({ post: "1" }));

                axios
                .post(this.$store.state.apiUrl+"?request=logout", formData, { withCredentials: true })
                .then((response) => {
                    if(response.data) {
                        this.$router.replace({ name: 'login' });
                    }
                });
            }
        }
    }
</script>

<style scoped src="@/assets/userPanel.css">
</style>
